import { defineComponent as _defineComponent } from 'vue'
import AdminNavigation from "../../AdminNavigationContainer.vue";
import { ref, onMounted, onBeforeUnmount, reactive, onUpdated } from "vue";
import { useI18n } from "vue3-i18n";
import ResponseData from "@/types/ResponseData";
import Loading from "@/components/home/Loading.vue";
import Alert from "@/components/scan/parts/Alert.vue";
import { store } from "@/store/store";
import GroupAdminService from "@/services/GroupAdminService";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const alertMessage = ref("null");
const alertState = ref("neutral");
const i18n = useI18n();
const title = ref(store.getters.showPageTitle);
const groupAdminListInfo = reactive([]);
const groupList = reactive([]);
const getData = ref(false);
const selectedGroup = ref("");
const isNoData = ref(false);
const selGroup = ref("");

/** 初期表示設定 */
onMounted(function () {
  window.addEventListener('resize', handleResize);
  isLoading.value = true;
  getGroupListInfo();
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});

function handleResize() {
  try {
    var tableHeight = 0;
    var dataHeight = document.getElementById("tbltbody")?.clientHeight;
    if (dataHeight != 0) {
      var mydivh = document.getElementById("mydiv")?.clientHeight;
      tableHeight = (mydivh * 96) / 100 - 184;
      document.getElementById("tblbodydiv").style.height = tableHeight + "px";
      if (dataHeight > tableHeight) {
        document.getElementById("tblbodydiv").style.width = "100%";
      } else {
        document.getElementById("tblbodydiv").style.width = "calc(100% - 16px)";
      }
    }
  } catch (e) {
    isLoading.value = false;
  }
}

/** Groupコンボボックスデータ取得 */
const getGroupListInfo = () => {
  alertMessage.value = "null";
  alertState.value = "neutral";
  isLoading.value = true;

  GroupAdminService.getGroupList()
    .then((response: ResponseData) => {
        selectedGroup.value = "";
        if (response.data.length !== 0) {
          selectedGroup.value = response.data[0]["group"];
        for (let info of response.data) {
            groupList.push(info);
        }
      }
      isLoading.value = false; 
    })
    .catch((e: Error) => {
      console.log(e);
      alertMessage.value = i18n.t("err071");
      alertState.value = "error";
      isLoading.value = false;
    });
};

/** 検索処理 */
const goSearch = () => {
  alertMessage.value = "null";
  alertState.value = "neutral";
  isLoading.value = false;
  groupAdminListInfo.splice(0);
  isNoData.value = false;

  const gdata = {
    groupId: selectedGroup.value,
  };
  GroupAdminService.getGroupAdminList(gdata)
    .then((response: ResponseData) => {
      if (response.data.length > 0) {
        for (let info of response.data) {
            groupAdminListInfo.push(info);
            selGroup.value=selectedGroup.value;
        }
      } else {
        isNoData.value = true;
      }
      isLoading.value = false;
    })
    .catch((e: Error) => {
      console.log(e);
      alertMessage.value = i18n.t("err071");
      alertState.value = "error";
      isLoading.value = false;
    });
};

const addGroupAdmin = () => {
  store.dispatch("setgroupUserId","")
  store.dispatch("setgroupLName", "");
  store.dispatch("setgroupFName", "");
  store.dispatch("setgroupEmail", "");
  store.dispatch("setgroup", "");
  store.dispatch("setShowPage", "GroupAdminRegisteration");
  store.dispatch("setShowPageTitle", "Group Admin Maintenance");
};

const updateGroups = (userid,gName,fName,Email,dept) => {
  store.dispatch("setgroupUserId",userid)
  store.dispatch("setgroupLName", gName);
  store.dispatch("setgroupFName", fName);
  store.dispatch("setgroupEmail", Email);
  store.dispatch("setgroup", dept);

  store.dispatch("setShowPage", "GroupAdminRegisteration");
  store.dispatch("setShowPageTitle", "Edit Group Admin");
};

onUpdated(function () {
  handleResize();
});

const __returned__ = { isLoading, alertMessage, alertState, i18n, title, groupAdminListInfo, groupList, getData, selectedGroup, isNoData, selGroup, handleResize, getGroupListInfo, goSearch, addGroupAdmin, updateGroups, AdminNavigation, Loading, Alert, store }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})